<template>
  <v-lazy
    class="card"
    :options="{
      threshold: 0.5,
    }"
    height="250"
    transition="fade-transition"
  >
    <div style="height: 100%">
      <img
        :class="$store.state.isMobile ? 'card-img' : 'card-img__desctop'"
        :src="item.photos[0]"
        alt="photo"
      />
      <div class="header__card">
        <div class="item__type">{{ item.status }}</div>
        <div class="checkbox_block">
          <label class="checkbox__label gray-text">
            <input
              class="checkbox"
              type="checkbox"
              id="withFinishing"
              v-model="selected"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <div class="description flex">
        <div class="description__block">
          <div class="title__block flex">
            <a class="title">{{ item.lot_name }}</a>
            <a class="price">
              <b class="full-price"
                ><span class="full-price">{{ item.currency }}</span
                >{{ item.fullPrice }}</b
              >
            </a>
          </div>

          <!--<p class="address">{{ item.lot_adress }}</p>-->

          <div class="characters-block flex">
            <div class="characters__floor flex align-center mr-1">
              <svg
                class="characters__icon"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.0383 2.22559H12.7501C12.2448 2.22559 11.8354 2.63472 11.8354 3.14009V5.51406H9.46149C8.95611 5.51406 8.54669 5.92304 8.54669 6.42845V8.80257H6.17272C5.66735 8.80257 5.25807 9.21214 5.25807 9.717V12.2055H2.77016C2.5274 12.2055 2.29476 12.3017 2.12331 12.473C1.95171 12.6444 1.85547 12.8781 1.85547 13.1199L1.85577 15.0332C1.85577 15.5391 2.26534 15.9482 2.77042 15.9482H16.0383C16.5437 15.9482 16.9529 15.5391 16.9529 15.0332V3.14005C16.953 2.63472 16.5437 2.22559 16.0383 2.22559Z"
                  fill="#8B9AB0"
                  fill-opacity="0.75"
                />
              </svg>
              <span class="gray-text characters__text">
                {{ item.lot_floor.split(":")[0] }}/{{
                  item.lot_floor.split(":")[1].trim()
                }}</span
              >
              <!--  <span class="gray-text characters__text">этаж</span>-->
            </div>
            <div class="characters__bedroom flex align-center mr-1">
              <svg
                class="characters__icon"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.43748 7.875V5.4375H7.125C6.40199 5.4375 5.91632 5.4387 5.55404 5.4874C5.20795 5.53393 5.05982 5.61435 4.96209 5.71209C4.86435 5.80983 4.78393 5.95795 4.7374 6.30404C4.68869 6.66632 4.6875 7.15199 4.6875 7.875H8.43748Z"
                  fill="#8B9AB0"
                  fill-opacity="0.75"
                />
                <path
                  d="M13.3126 7.875C13.3126 7.15199 13.3114 6.66632 13.2627 6.30404C13.2162 5.95795 13.1357 5.80983 13.038 5.71209C12.9403 5.61435 12.7921 5.53393 12.446 5.4874C12.0838 5.4387 11.5981 5.4375 10.8751 5.4375H9.56256V7.875H13.3126Z"
                  fill="#8B9AB0"
                  fill-opacity="0.75"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.74994 3.00003H8.24994C5.42153 3.00003 4.00732 3.00003 3.12864 3.87871C2.36179 4.64556 2.26419 5.82032 2.25177 7.98708V9.19991C1.96651 9.36408 1.74144 9.61863 1.61412 9.92598C1.49994 10.2017 1.49994 10.5511 1.49994 11.25C1.49994 11.949 1.49994 12.2984 1.61412 12.5741C1.76636 12.9416 2.05837 13.2336 2.42591 13.3859C2.6152 13.4643 2.8393 13.4889 3.18744 13.4965V15C3.18744 15.3107 3.43928 15.5625 3.74994 15.5625C4.0606 15.5625 4.31244 15.3107 4.31244 15V13.5H13.6874V15C13.6874 15.3107 13.9393 15.5625 14.2499 15.5625C14.5606 15.5625 14.8124 15.3107 14.8124 15V13.4965C15.1606 13.4889 15.3847 13.4643 15.574 13.3859C15.9415 13.2336 16.2335 12.9416 16.3858 12.5741C16.4999 12.2984 16.4999 11.949 16.4999 11.25C16.4999 10.5511 16.4999 10.2017 16.3858 9.92598C16.2584 9.61863 16.0334 9.36408 15.7481 9.19998V7.98708C15.7358 5.82032 15.6381 4.64556 14.8713 3.87871C13.9926 3.00003 12.5784 3.00003 9.74994 3.00003ZM14.4374 9.0001V7.83603C14.4375 7.16219 14.4375 6.60024 14.3775 6.15417C14.3142 5.68333 14.1749 5.25823 13.8334 4.91663C13.4918 4.57502 13.0667 4.43577 12.5958 4.37246C12.1497 4.31249 11.5878 4.31251 10.9139 4.31253H7.08596C6.4121 4.31251 5.85019 4.31249 5.4041 4.37246C4.93326 4.43577 4.50815 4.57502 4.16656 4.91663C3.82495 5.25823 3.68569 5.68333 3.62239 6.15417C3.56242 6.60026 3.56244 7.16217 3.56246 7.83603V9.0001C3.62203 9.00003 3.68446 9.00003 3.74994 9.00003H14.2499C14.3154 9.00003 14.3779 9.00003 14.4374 9.0001Z"
                  fill="#8B9AB0"
                  fill-opacity="0.75"
                />
              </svg>
              <span class="gray-text characters__text">{{
                item.lot_bedroom
              }}</span>
              <span class="gray-text"> спальни</span>
            </div>

            <!--  <div class="characters characters__wc flex">
              <svg
                class="characters__icon"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.75 7.49965H5.25V5.3344C5.25 4.58665 5.7585 3.89215 6.49575 3.77065C6.71109 3.73401 6.93184 3.74477 7.1426 3.80218C7.35336 3.8596 7.54906 3.96229 7.71607 4.10309C7.88308 4.24389 8.01737 4.41942 8.10958 4.61744C8.20179 4.81546 8.24971 5.03121 8.25 5.24965H9.75C9.74964 4.83063 9.66156 4.41632 9.49145 4.03338C9.32133 3.65044 9.07293 3.30735 8.76224 3.02619C8.45155 2.74503 8.08544 2.53202 7.68747 2.40086C7.2895 2.2697 6.86848 2.2233 6.4515 2.26465C4.89225 2.41615 3.75 3.8164 3.75 5.38315V7.49965H2.25C2.05109 7.49965 1.86032 7.57867 1.71967 7.71932C1.57902 7.85997 1.5 8.05074 1.5 8.24965V9.74965C1.5 11.7042 2.7555 13.3669 4.5 13.9872V16.4997H6V14.2497H12V16.4997H13.5V13.9872C15.2445 13.3669 16.5 11.7042 16.5 9.74965V8.24965C16.5 8.05074 16.421 7.85997 16.2803 7.71932C16.1397 7.57867 15.9489 7.49965 15.75 7.49965Z"
                  fill="#8B9AB0"
                  fill-opacity="0.75"
                />
              </svg>

              <span class="gray-text characters__text">{{ item.wc }}</span>
              <span class="gray-text"> санузла</span>
            </div>-->
            <div class="characters__area flex align-center mr-1">
              <svg
                class="characters__icon"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.93762 2.25003C3.00564 2.25003 2.25012 3.00555 2.25012 3.93753V14.0625C2.25012 14.9945 3.00564 15.75 3.93762 15.75H14.0626C14.9946 15.75 15.7501 14.9945 15.7501 14.0625V3.93753C15.7501 3.00555 14.9946 2.25003 14.0626 2.25003H3.93762ZM4.50012 5.06253C4.50012 4.75187 4.75196 4.50003 5.06262 4.50003H6.93762C7.24828 4.50003 7.50012 4.75187 7.50012 5.06253C7.50012 5.37319 7.24828 5.62503 6.93762 5.62503H6.42062L7.71035 6.91478C7.93002 7.13445 7.93002 7.49061 7.71035 7.71026C7.4907 7.92993 7.13454 7.92993 6.91488 7.71026L5.62512 6.42053V6.93839C5.62512 7.24905 5.37328 7.50093 5.06262 7.50093C4.75196 7.50093 4.50012 7.24905 4.50012 6.93839V5.06253ZM13.3357 13.3361C13.2303 13.4416 13.0872 13.5009 12.938 13.5009H11.063C10.7523 13.5009 10.5005 13.249 10.5005 12.9384C10.5005 12.6277 10.7523 12.3759 11.063 12.3759H11.5801L10.2897 11.0853C10.0701 10.8656 10.0701 10.5094 10.2898 10.2897C10.5095 10.0701 10.8657 10.0701 11.0853 10.2898L12.3755 11.5802V11.0625C12.3755 10.7518 12.6273 10.5 12.938 10.5C13.2486 10.5 13.5005 10.7518 13.5005 11.0625V12.9384C13.5005 13.0875 13.4412 13.2306 13.3357 13.3361ZM13.5005 5.06299V6.93799C13.5005 7.24865 13.2486 7.50048 12.938 7.50048C12.6273 7.50048 12.3755 7.24865 12.3755 6.93799V6.42059L11.0852 7.71033C10.8654 7.93001 10.5093 7.92993 10.2897 7.71018C10.0701 7.49048 10.0701 7.13433 10.2899 6.9147L11.5796 5.62549H11.0621C10.7514 5.62549 10.4996 5.37365 10.4996 5.06299C10.4996 4.75233 10.7514 4.50049 11.0621 4.50049H12.938C13.0872 4.50049 13.2303 4.55975 13.3357 4.66524C13.4412 4.77073 13.5005 4.91381 13.5005 5.06299ZM4.66487 13.3356C4.55939 13.2302 4.50012 13.0871 4.50012 12.9379V11.0629C4.50012 10.7523 4.75196 10.5004 5.06262 10.5004C5.37328 10.5004 5.62512 10.7523 5.62512 11.0629V11.5797L6.91484 10.2898C7.1345 10.0701 7.49065 10.0701 7.71035 10.2897C7.93002 10.5094 7.93002 10.8656 7.71042 11.0853L6.42046 12.3754H6.93848C7.24915 12.3754 7.50102 12.6273 7.50102 12.9379C7.50102 13.2486 7.24914 13.5004 6.93848 13.5004H5.06262C4.91344 13.5004 4.77036 13.4412 4.66487 13.3356Z"
                  fill="#8B9AB0"
                  fill-opacity="0.75"
                />
              </svg>
              <span class="gray-text characters__text">{{
                item.lot_square
              }}</span>
              <span class="gray-text">м²</span>
            </div>
            <div
              class="characters__otd flex align-center mr-1"
              v-if="item.lot_otc"
            >
              <svg
                class="characters__icon"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.125 14.625V13.5H3.375C2.9625 13.5 2.5875 13.335 2.3175 13.0575C2.04 12.7875 1.875 12.4125 1.875 12C1.875 11.2275 2.475 10.5825 3.2325 10.5075C3.2775 10.5 3.3225 10.5 3.375 10.5H14.625C14.6775 10.5 14.7225 10.5 14.7675 10.5075C15.1275 10.5375 15.4425 10.695 15.6825 10.9425C15.99 11.2425 16.155 11.67 16.1175 12.135C16.05 12.9225 15.3375 13.5 14.5425 13.5H10.875V14.625C10.875 15.66 10.035 16.5 9 16.5C7.965 16.5 7.125 15.66 7.125 14.625Z"
                  fill="#A8B3C4"
                />
                <path
                  d="M12.8929 1.5H9.93795C9.72795 1.5 9.56295 1.665 9.56295 1.875V3C9.56295 3.3075 9.30795 3.5625 9.00045 3.5625C8.93295 3.5625 8.87295 3.5475 8.81295 3.525C8.59545 3.45 8.43795 3.24 8.43795 3V1.875C8.43795 1.665 8.27295 1.5 8.06295 1.5H6.93043C6.72043 1.5 6.55543 1.665 6.55543 1.875V5.25C6.55543 5.5575 6.30043 5.8125 5.99293 5.8125C5.68543 5.8125 5.43043 5.5575 5.43043 5.25V3.5625V1.875C5.43043 1.6725 5.28043 1.515 5.07793 1.5H5.05543C3.75043 1.53 2.73793 2.6625 2.87293 3.975L3.15043 9.0375C3.17293 9.435 3.50293 9.75 3.90043 9.75H14.1004C14.4979 9.75 14.8279 9.435 14.8504 9.0375L15.1279 3.975C15.2629 2.6475 14.2204 1.5 12.8929 1.5Z"
                  fill="#A8B3C4"
                />
              </svg>
              <span class="gray-text characters__text">{{ item.lot_otc }}</span>
            </div>
          </div>
        </div>
        <!--<div class="id-block flex">
          <b class="ident">ID: {{ item.id }}</b>
        </div>-->
      </div>
    </div>
  </v-lazy>
</template>

<script>
export default {
  name: "Card-Component",
  props: {
    item: Object,
    modelValue: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      selected: false,
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        if (!val.selected) {
          this.selected = false;
        }
        console.log({ val });
      },
    },
    selected(val) {
      this.$emit("update:modelValue", val);
      if (this.selected) {
        const index = this.$store.state.selectItems.findIndex(
          (e) => e.id == this.item.id
        );
        if (index == -1) {
          this.$store.commit("addSelectItems", this.item);
        }
      } else {
        this.$store.commit("deleteSelectItems", this.item);
      }
    },
  },
  created() {
    this.selected = this.item.selected;
  },
};
</script>

<style scoped>
.card {
  position: relative;
  border: 1px solid #e5e5e5;
  border-radius: 20px;
}
.card__block {
  flex-direction: column;
}
.card-img {
  width: 100%;
  height: 50%;
  border-radius: 20px;
  object-fit: cover;
}
.card-img__desctop {
  width: 100%;
  height: 40%;
  border-radius: 20px;
  object-fit: cover;
}
.description {
  flex-direction: column;
  padding: 12px;
  height: 50%;
}
.description__basic {
  height: 90%;
}
.characters-block {
  flex-wrap: wrap;
  margin-block: 10px;
}
.id-block {
  justify-content: end;
}
.title__block {
  justify-content: space-between;
  margin-bottom: 10px;
}
.price {
  font-size: 20px;
  color: #ff8351;
}
.address {
  font-size: 14px;
  font-weight: 400;
}
.characters {
  display: flex;
  align-items: center;
  margin-right: 5px;
}
.characters__text {
  margin-right: 3px;
}
.characters__icon {
  margin-right: 3px;
}
.status-block {
  flex-direction: row;
}
.item__type {
  position: absolute;
  padding: 0 4px;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
  top: 18px;
  left: 15px;
}
.checkbox_block {
  position: absolute;
  top: 15px;
  right: 0;
}
.checkbox_label {
  padding: 0;
  margin: 0;
}
</style>
